type GetCurrentUserResponse =
  overwolfInternal.profile.model.GetCurrentUserResponse;

// -----------------------------------------------------------------------------
export class OWInternalProfile {
  // ---------------------------------------------------------------------------
  public static async getCurrentUser(): Promise<GetCurrentUserResponse> {
    return new Promise((resolve, reject) => {
      overwolfInternal.profile.getCurrentUser(result => {
        if (result.status !== 'success') {
          return reject(result);
        }

        return resolve(result);
      });
    });
  }
}
